import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import { instance } from "Actions/AxiosInstance";
import { setSaveProgress, removeSaveProgress } from "Actions/SaveProgressAction";
import addPlusIcon from "Assets/newicons/action/add-plus/outline/add-plus-outline-16px-blue.svg";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import editIcon from "Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import designationIcon from "Assets/newicons/attribute/designation/outline/designation-outline-16px.svg";
import kebabIcon from "Assets/newicons/user-interface/kebab/glyph/kebab-glyph-16px.svg";
import alpha from "Assets/Svg/alpha-numeric.svg";
import dton from "Assets/Svg/date.svg";
import drag from "Assets/Svg/drag.svg";
import dropdown from "Assets/Svg/dropdown-selection.svg";
import checkboxIcon from "Assets/Svg/list-checkbox.svg";
import num from "Assets/Svg/numerical.svg";
import classNames from "classnames";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import DrawerHeader from "Component/Headers/drawerHeader";
import IconLabel from "Component/Labels/IconLabel";
import { ErrorMessages } from "Constants";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AddJobDrawer from "./AddJobDrawer";

const questioncategories = [
  {
    displayname: "Functional and role questions",
    displayvalue: 1,
  },
  {
    displayname: "New questions",
    displayvalue: 2,
  },
];

const styles = () => ({
  drawerPaper: {
    width: "30%",
    padding: 16,
  },
});

class AddJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tempRequistionJobs: null,
      postData: props.postData,
      drawerOpen: false,
      saveincompany: false,
      moreoptions: false,
      moreoptions_anchorEl: null,
      questiontypeid: null,
      description: "",
      answertypeid: 0,
      idx: "",
      option: [],
      allemployees: [],
      isnotifyemployee: false,
      requisitionTitle: "",
      expanded: false,
      jobAdded: false,
      jobexpanded: false,
      isAddJob: true,
      isAddQuestion: false,
      createmenu: false,
      create_anchorEl: null,
      jobindex: null,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.setInputType = this.setInputType.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addOption = this.addOption.bind(this);
    this.addMultiOption = this.addMultiOption.bind(this);
    this.removeOption = this.removeOption.bind(this);
    this.createNewMenuClose = this.createNewMenuClose.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
  }

  componentDidMount() {
    this.getQuestion();
    this.getAllEmp();
    this.props.onRef({
      onNext: this.onSubmit,
    });
  }

  getQuestion = () => {
    instance
      .post("recruit/getallquestionbycategory", {
        questioncategoryid: 2,
        isactive: null,
      })
      .then((result) => {
        this.setState({
          arrQuestion: result.data.result.map((x) => ({
            ...x,
            displayname: x.questiontext,
            displayvalue: x.questionid,
          })),
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  addOption() {
    const { tempRequistionQuestion } = this.state;
    if (
      tempRequistionQuestion &&
      tempRequistionQuestion.question &&
      !tempRequistionQuestion.question.requisitionjobquestioninputoption
    ) {
      tempRequistionQuestion.question.requisitionjobquestioninputoption = [];
    }
    tempRequistionQuestion &&
      tempRequistionQuestion.question &&
      tempRequistionQuestion.question.requisitionjobquestioninputoption.push({
        requisitionjobquestioninputoptionid: null,
        questioninputoptionid: null,
        optionname: null,
        optionorder: null,
      });
    this.setState({
      tempRequistionQuestion,
    });
  }

  handleExpandClick = () => {
    this.setState((state) => ({
      expanded: !state.expanded,
      jobAdded: false,
      jobexpanded: false,
      tempRequistionJobs: null,
      tempRequistionQuestion: null,
    }));
  };

  addMultiOption() {
    const mulitiselectoption = [];
    mulitiselectoption.push({
      mulitiselectoptionname: null,
    });
    this.setState({
      mulitiselectoption,
    });
  }

  removeOption(index) {
    const { tempRequistionQuestion } = this.state;
    tempRequistionQuestion &&
      tempRequistionQuestion.question &&
      tempRequistionQuestion.question.requisitionjobquestioninputoption.splice(
        index,
        1,
      );
    this.setState({
      tempRequistionQuestion,
    });
  }

  setInputType(answertypeid) {
    const { tempRequistionQuestion } = this.state;
    tempRequistionQuestion.question.inputvaluetypeid = answertypeid;
    tempRequistionQuestion.question.requisitionjobquestioninputoption = [];
    this.setState({
      tempRequistionQuestion,
    });
  }

  onMoreOptionsClick = (event, key, data, index) => {
    this.setState({
      moreoptions: !this.state.moreoptions,
      moreoptions_anchorEl: event.currentTarget,
      action: key,
      questionindex: key === "addQuestion" ? index : this.state.questionindex,
      tempRequistionQuestion:
        key === "addQuestion" ? data : this.state.tempRequistionQuestion,
      selectedRequistionJobs:
        key === "editRequisition" ? data : this.state.tempRequistionJobs,
      jobindex: key === "editRequisition" ? index : this.state.jobindex,
    });
  };

  handleChange(key, value, index) {
    if (key == "questionid") {
      const { tempRequistionQuestion, arrQuestion } = this.state;
      tempRequistionQuestion[key] = value;
      tempRequistionQuestion.questiontext = arrQuestion.find(
        (x) => x.questionid == value,
      ).questiontext;
      this.setState({
        tempRequistionQuestion,
      });
    } else if (key == "questiontext") {
      const { tempRequistionQuestion } = this.state;
      tempRequistionQuestion.question[key] = value;
      tempRequistionQuestion.question.questioncategoryid = 2;
      this.setState({
        tempRequistionQuestion,
      });
    } else if (key == "optionname") {
      const { tempRequistionQuestion } = this.state;
      tempRequistionQuestion.question.requisitionjobquestioninputoption[index][
        key
      ] = value;
      tempRequistionQuestion.question.requisitionjobquestioninputoption[
        index
      ].optionorder = index + 1;
      this.setState({
        tempRequistionQuestion,
      });
    } else if (key == "savecompany") {
      this.setState({
        key: value,
      });
    } else {
      this.setState({
        [key]: value,
      });
    }
  }

  createNewMenuClose() {
    this.setState({ createmenu: false, selectedRow: null });
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  onSaveQuestion = () => {
    const {
      tempRequistionQuestion,
      tempRequistionJobs,
      questionindex,
      saveincompany,
    } = this.state;
    tempRequistionJobs.requisitionjobquestion =
      tempRequistionJobs.requisitionjobquestion || [];

    if (questionindex != null) {
      tempRequistionJobs.requisitionjobquestion[questionindex] =
        tempRequistionQuestion;
    } else {
      tempRequistionJobs.requisitionjobquestion.find(
        (question) =>
          tempRequistionQuestion.questionid &&
          question.questionid == tempRequistionQuestion.questionid,
      )
        ? this.props.enqueueSnackbar("Question already added", {
            variant: "error",
          })
        : tempRequistionJobs.requisitionjobquestion.push(
            tempRequistionQuestion,
          );
    }

    if (
      this.state.questiontypeid == 2 &&
      this.state.tempRequistionQuestion &&
      !this.state.tempRequistionQuestion.question.questiontext
    ) {
      this.props.enqueueSnackbar("Please enter question", { variant: "error" });
    } else if (
      this.state.questiontypeid == 1 &&
      this.state.tempRequistionQuestion &&
      !this.state.tempRequistionQuestion.questionid
    ) {
      this.props.enqueueSnackbar("Please select question", {
        variant: "error",
      });
    } else if (
      this.state.questiontypeid == 2 &&
      !this.state.tempRequistionQuestion.question.inputvaluetypeid
    ) {
      this.props.enqueueSnackbar("Please select answer type", {
        variant: "error",
      });
    } else {
      if (saveincompany && tempRequistionQuestion.question) {
        this.addFunctionalScreeningQuestion(tempRequistionQuestion.question);
      }

      this.setState({
        tempRequistionJobs,
        drawerOpen: false,
        isAddQuestion: false,
        isAddJob: false,
      });
    }
  };

  addFunctionalScreeningQuestion = (objQuestion) => {
    const objQuestionPostData = objQuestion;
    if (objQuestion.requisitionjobquestioninputoption) {
      objQuestionPostData.questioninputoption =
        objQuestion.requisitionjobquestioninputoption.map((option) => ({
          questioninputoptionid: option.questioninputoptionid,
          optionname: option.optionname,
          optionorder: option.optionorder,
        }));
    }
    instance
      .post("recruit/configquestion", objQuestionPostData)
      .then(() => {
        this.setState({
          saveincompany: false,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  onJobSave = (index = null) => {
    const { postData, tempRequistionJobs } = this.state;

    if (
      !(
        tempRequistionJobs.requisitionjobquestion &&
        tempRequistionJobs.requisitionjobquestion.length
      )
    ) {
      this.props.enqueueSnackbar("Please add ateleast one question", {
        variant: "error",
      });
      return;
    }

    if (index != null) {
      postData.requisitionjob[index] = tempRequistionJobs;
    } else if (tempRequistionJobs.jobtemplateid == null) {
      this.props.enqueueSnackbar("Please add job", { variant: "error" });
      this.setState({ expanded: true });
    } else {
      postData.requisitionjob.push(tempRequistionJobs);
    }
    this.setState({
      expanded: false,
      tempRequistionJobs: null,
      postData,
      jobexpanded: false,
      drawerOpen: false,
      isAddQuestion: false,
      isAddJob: false,
      editSelectedRequistionjob: false,
    });
  };

  onSubmit = () => {
    const { postData } = this.state;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    postData.isdraft = false;
    const isCheck = true;
    delete postData.addedby;

    if (isCheck == false) {
      this.props.enqueueSnackbar("Please fill the data", { variant: "error" });
    } else if (postData.requisitionjob.length == 0) {
      this.props.enqueueSnackbar("Please add job", { variant: "error" });
    } else {
      postData.requisitionjob.map((item) => {
        item.officeaddressids = `${item.officeaddressids}`;
        item.requisitionjobquestion &&
          item.requisitionjobquestion.map((element, index) => {
            element.questionorder = index + 1;
            delete element.questiontext;
            element.questiontypeid = 2;

            if (element.questionid) {
              element.questiontypeid = 1;
              element.question = null;
              element.questioncategoryid = element.questioncategoryid
                ? element.questioncategoryid
                : 2;
            } else {
              element.questioncategoryid = 2;
            }
          });
      });
      postData.noofjobs = postData.requisitionjob.length;
      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
        instance
        .post("recruit/configrequisition", postData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          // this.props.history.push(`${this.props.match.path}/list`);
          this.props.getAllRequisition(true);
          this.props.history.push(`${this.props.match.url}/requisition`);
          this.props.removeSaveProgress();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
          this.props.removeSaveProgress();
        });
      }
    }
  };

  getAllEmp() {
    const arr = this.props.location.pathname.split("/");
    const { login } = this.props;
    const data = {
      // featurekey: "okr",
      subscriptionid: login.subscriptionid,
      statusid: 1,
    };
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {
        this.setState({
          allemployees: result.data.result,
          employeeid: arr && arr[6],
          SelectedEmpData:
            arr &&
            arr[6] &&
            result.data.result.find((x) => x.displayvalue == arr[6])
              ? result.data.result.find((x) => x.displayvalue == arr[6])
              : null,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  updatePostData = (tempRequistionJobs) => {
    // const { postData } =  this.state;
    // postData.requisitionjob.push(tempRequistionJobs);
    this.setState({
      tempRequistionJobs,
      jobAdded: true,
      drawerOpen: false,
      isAddQuestion: false,
      isAddJob: false,
    });
  };

  editPopover = () => {
    if (this.state.action === "addQuestion") {
      this.setState({
        isAddQuestion: true,
        drawerOpen: true,
        isAddJob: false,
        createmenu: false,
        moreoptions: false,
        questionindex: null,
        tempRequistionQuestion: null,
        questiontypeid: null,
      });
    } else if (this.state.action === "editRequisition") {
      this.setState({
        jobexpanded: true,
        createmenu: false,
        moreoptions: false,
        editSelectedRequistionjob: true,
        tempRequistionJobs: this.state.selectedRequistionJobs || null,
      });
    }
  };

  deletePopover = () => {
    const { action } = this.state;

    if (action === "editQuestion" || action === "addQuestion") {
      this.props.enqueueSnackbar("Are you sure you want to delete?", {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={this.onDeleteQuestion}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      });
    } else if (action === "editRequisition") {
      this.props.enqueueSnackbar("Are you sure you want to delete?", {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={this.onDeleteJob}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      });
    }
  };

  onDeleteJob = () => {
    this.props.closeSnackbar();
    const { selectedRequistionJobs, postData } = this.state;

    if (selectedRequistionJobs.requisitionjobid) {
      instance
        .post(
          `recruit/deleterequisitionjob/${selectedRequistionJobs.requisitionjobid}`,
        )
        .then(
          () => {
            this.props.enqueueSnackbar("Deleted successfully", {
              variant: "success",
            });
            this.props.closeSnackbar();
            postData.requisitionjob.splice(this.state.jobindex, 1);
            this.setState({
              moreoptions: false,
              moreoptions_anchorEl: null,
              postData,
              jobexpanded: false,
              createmenu: false,
              selectedRequistionJobs: null,
              selectedRequistionQuestion: null,
            });
          },
          (error) => {
            const CommonError = error.response
              ? error.response.data.error.message
              : error.message;
            this.props.enqueueSnackbar(CommonError, { variant: "error" });
            this.props.closeSnackbar();
          },
        );
    } else {
      postData.requisitionjob.splice(this.state.jobindex, 1);
      this.setState({
        postData,
        moreoptions: false,
        moreoptions_anchorEl: null,
        jobexpanded: false,
        createmenu: false,
      });
    }
  };

  onDeleteQuestion = () => {
    this.props.closeSnackbar();
    const { tempRequistionJobs, questionindex } = this.state;

    tempRequistionJobs.requisitionjobquestion.splice(questionindex, 1);
    this.setState({
      tempRequistionJobs,
      questionindex: null,
      moreoptions: !this.state.moreoptions,
      moreoptions_anchorEl: null,
    });
  };

  render() {
    const { questiontypeid, idx, saveincompany, postData, tempRequistionJobs } =
      this.state;
    const { requisitionjob } = postData;
    const { classes } = this.props;

    return (
      <div>
        {!this.state.editSelectedRequistionjob && (
          <ExpansionPanel
            expanded={this.state.expanded}
            onChange={() => this.handleExpandClick(this.state.expanded)}
            className="rounded-rectangle-paper rounded-rectangle-div padding0"
            style={{ border: "1px solid #1E8CED" }}
          >
            <ExpansionPanelSummary
              // expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              style={this.state.expanded ? { height: 0, minHeight: 0 } : {}}
            >
              {!this.state.expanded ? (
                <div>
                  <span className="margin-right-8">
                    <img src={addPlusIcon}></img>
                  </span>
                  <p className="small-blue inline-block">Add new job</p>
                </div>
              ) : (
                ""
              )}
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className="display-block padding-top-24 padding-bottom-24">
              <p className="normal-dark-secondary margin-bottom-8">Job</p>
              {this.state.jobAdded || this.state.tempRequistionJobs ? (
                <div
                  className="rounded-rectangle-div margin-bottom-16"
                  style={{ width: 300 }}
                >
                  <span
                    className="display-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <IconLabel
                      label={
                        this.props.initData &&
                        tempRequistionJobs &&
                        tempRequistionJobs.jobtemplateid &&
                        this.props.initData.jobTemplate.find(
                          (x) =>
                            x.displayvalue == tempRequistionJobs.jobtemplateid,
                        ).displayname
                      }
                      className="margin-bottom-8"
                      img={designationIcon}
                    />
                    <div className="display-flex">
                      <img
                        src={editIcon}
                        height="16"
                        className="margin-right-8"
                        onClick={() =>
                          this.setState({ isAddJob: true, drawerOpen: true })
                        }
                      ></img>
                      <img
                        src={deleteIcon}
                        height="16"
                        onClick={() =>
                          this.setState({
                            tempRequistionJobs: null,
                            jobAdded: false,
                          })
                        }
                      ></img>
                    </div>
                  </span>

                  <p className="extra-small-dark-secondary">
                    {tempRequistionJobs &&
                      tempRequistionJobs.availableposition &&
                      tempRequistionJobs.availableposition}{" "}
                    positions
                  </p>
                </div>
              ) : (
                <Button
                  className="btn btn-secondary-md-blue"
                  variant="contained"
                  onClick={() =>
                    this.setState({
                      drawerOpen: true,
                      isAddQuestion: false,
                      isAddJob: true,
                      tempRequistionJobs: null,
                      tempRequistionQuestion: null,
                    })
                  }
                >
                  Add job
                </Button>
              )}
              {tempRequistionJobs && tempRequistionJobs.jobtemplateid && (
                <div style={{ width: 350 }} className="margin-top-16">
                  <p className="normal-dark-secondary">
                    Screening questions (Functional)
                  </p>
                </div>
              )}

              {tempRequistionJobs &&
                tempRequistionJobs.requisitionjobquestion &&
                tempRequistionJobs.requisitionjobquestion.map((item, index) => (
                  <Paper
                    className="rounded-rectangle-paper margin-bottom-16"
                    style={{ padding: "8px 32px" }}
                  >
                    <Grid container>
                      <Grid item md={1} sm={12}>
                        <img src={drag} className="vertical-middle"></img>
                      </Grid>
                      <Grid item md={11} sm={12}>
                        <div className="floatleft">
                          <p className="small-dark-secondary t-bold padding-top-8">
                            {item.questiontext ||
                              (item.question && item.question.questiontext)}
                          </p>
                        </div>
                        <div
                          className="floatright padding-top-10"
                          onClick={(e) =>
                            this.onMoreOptionsClick(
                              e,
                              "addQuestion",
                              item,
                              index,
                            )
                          }
                        >
                          <img src={kebabIcon}></img>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                ))}

              {tempRequistionJobs && tempRequistionJobs.jobtemplateid && (
                <div style={{ width: 350 }} className="margin-top-8">
                  <Button
                    className="btn btn-secondary-md-blue"
                    variant="contained"
                    onClick={() =>
                      this.setState({
                        drawerOpen: true,
                        isAddQuestion: true,
                        isAddJob: false,
                        questioncategoryid: null,
                        questionindex: null,
                        tempRequistionQuestion: {
                          requisitionjobquestionid: null,
                          questionid: null,
                          questiontypeid: null,
                          question: {},
                        },
                      })
                    }
                  >
                    Add screening question
                  </Button>
                </div>
              )}
              {tempRequistionJobs && tempRequistionJobs.jobtemplateid && (
                <div>
                  <Button
                    className="btn btn-primary-md-blue margin-top-16"
                    variant="contained"
                    onClick={() => this.onJobSave(null)}
                  >
                    Save job
                  </Button>
                  <Button
                    className="btn btn-trans margin-top-16"
                    variant="contained"
                    onClick={() =>
                      this.setState({
                        expanded: false,
                        tempRequistionJobs: null,
                        tempRequistionQuestion: null,
                        jobexpanded: false,
                        drawerOpen: false,
                        isAddQuestion: false,
                        isAddJob: false,
                        editSelectedRequistionjob: false,
                      })
                    }
                  >
                    Cancel
                  </Button>
                </div>
              )}
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )}
        <div className="dashed-divider1"></div>
        {requisitionjob &&
          requisitionjob.length != 0 &&
          requisitionjob.map((item, index) => (
            <React.Fragment>
              <ExpansionPanel
                expanded={
                  this.state.jobexpanded && this.state.jobindex == index
                }
                className="rounded-rectangle-paper margin-bottom-16"
              >
                <ExpansionPanelSummary
                  // expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  className={this.state.jobexpanded ? "display-none" : ""}
                >
                  {this.state.jobexpanded ? (
                    ""
                  ) : (
                    <div
                      className="display-flex width100"
                      style={{ justifyContent: "space-between" }}
                      onChange={() => this.setState({ jobexpanded: false })}
                    >
                      <div>
                        <IconLabel
                          label={
                            this.props.initData &&
                            item.jobtemplateid &&
                            this.props.initData.jobTemplate.find(
                              (x) => x.displayvalue == item.jobtemplateid,
                            ).displayname
                          }
                          className="margin-bottom-8"
                          img={designationIcon}
                        />
                        <p className="extra-small-dark-secondary">
                          {item.availableposition} positions
                        </p>
                        {/* <IconLabel
                      label="employee name"
                      labelClassNames="t-12 t-500"
                      img={userIcon}
                    /> */}
                      </div>
                      <div>
                        <img
                          src={kebabIcon}
                          onClick={(e) =>
                            this.onMoreOptionsClick(
                              e,
                              "editRequisition",
                              item,
                              index,
                            )
                          }
                        ></img>
                        {/* <p className="extra-small-dark-secondary margin-top-10">
                      {(item.requisitionjobquestion && item.requisitionjobquestion.length) || 0}
                    </p> */}
                      </div>
                    </div>
                  )}
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className="display-block padding-top-24 padding-bottom-24">
                  <p className="normal-dark-secondary margin-bottom-8">Job</p>

                  <div
                    className="rounded-rectangle-div margin-bottom-16"
                    style={{ width: 230 }}
                  >
                    <span
                      className="display-flex"
                      style={{ justifyContent: "space-between" }}
                    >
                      <IconLabel
                        label={
                          this.props.initData &&
                          item.jobtemplateid &&
                          this.props.initData.jobTemplate.find(
                            (x) => x.displayvalue == item.jobtemplateid,
                          ).displayname
                        }
                        className="margin-bottom-8"
                        img={designationIcon}
                      />
                      <div className="display-flex">
                        <img
                          src={editIcon}
                          height="16"
                          onClick={() =>
                            this.setState({ isAddJob: true, drawerOpen: true })
                          }
                          className="margin-right-8"
                        ></img>
                        {/* <img src={deleteIcon} height="16"
                        onClick={() => this.onDeleteJob1()}></img> */}
                      </div>
                    </span>
                    <p className="small-dark-secondary">
                      {item && item.availableposition} positions
                    </p>
                  </div>
                  <div style={{ width: 350 }} className="margin-top-16">
                    <p className="normal-dark-secondary margin-bottom-8">
                      Screening questions (Functional)
                    </p>
                  </div>
                  {item &&
                    item.requisitionjobquestion &&
                    item.requisitionjobquestion.filter(
                      (questiontype) => questiontype.questioncategoryid != 1,
                    ).map(
                      (element, questionindex) => (
                        <Paper
                          className="rounded-rectangle-paper margin-bottom-16"
                          style={{ padding: "8px 32px" }}
                        >
                          <Grid container>
                            <Grid item md={1} sm={12}>
                              <img src={drag} className="vertical-middle"></img>
                            </Grid>
                            <Grid item md={11} sm={12}>
                              <div className="floatleft">
                                <p className="small-dark-secondary t-bold padding-top-8">
                                  {element.questiontext ||
                                    (element.question &&
                                      element.question.questiontext)}
                                </p>
                              </div>
                              <div
                                className="floatright padding-top-10"
                                onClick={(e) =>
                                  element.questioncategoryid != 1 &&
                                  this.onMoreOptionsClick(
                                    e,
                                    "editQuestion",
                                    element,
                                    questionindex,
                                  )
                                }
                              >
                                <img src={kebabIcon}></img>
                              </div>
                            </Grid>
                          </Grid>
                        </Paper>
                      ),
                    )}

                  <p className="normal-dark-secondary margin-bottom-8 margin-top-16">
                    Screening questions (Company and culture)
                  </p>

                  {item &&
                    item.requisitionjobquestion &&
                    item.requisitionjobquestion
                      .filter(
                        (questiontype) => questiontype.questioncategoryid == 1,
                      )
                      .map((element, questionindex) => (
                        <Paper
                          className="rounded-rectangle-paper margin-bottom-16"
                          style={{ padding: "8px 32px" }}
                        >
                          <Grid container>
                            <Grid item md={1} sm={12}>
                              <img src={drag} className="vertical-middle"></img>
                            </Grid>
                            <Grid item md={11} sm={12}>
                              <div className="floatleft">
                                <p className="small-dark-secondary t-bold padding-top-8">
                                  {element.questiontext ||
                                    (element.question &&
                                      element.question.questiontext)}
                                </p>
                              </div>
                            </Grid>
                          </Grid>
                        </Paper>
                      ))}

                  <div style={{ width: 350 }} className="margin-top-16">
                    <Button
                      className="btn btn-secondary-md-blue"
                      variant="contained"
                      onClick={() =>
                        this.setState({
                          drawerOpen: true,
                          isAddQuestion: true,
                          isAddJob: false,
                          tempRequistionQuestion: {
                            requisitionjobquestionid: null,
                            questionid: null,
                            questiontypeid: null,
                            question: {},
                          },
                        })
                      }
                    >
                      Add screening question
                    </Button>
                  </div>
                  <Button
                    className="btn btn-primary-md-blue margin-top-16"
                    variant="contained"
                    onClick={() => this.onJobSave(index)}
                  >
                    Save job
                  </Button>
                  <Button
                    className="btn btn-trans margin-top-16"
                    variant="contained"
                    onClick={() =>
                      this.setState({
                        expanded: false,
                        tempRequistionJobs: null,
                        tempRequistionQuestion: null,
                        jobexpanded: false,
                        drawerOpen: false,
                        isAddQuestion: false,
                        isAddJob: false,
                        editSelectedRequistionjob: false,
                      })
                    }
                  >
                    Cancel
                  </Button>
                  <Popover
                    open={this.state.createmenu}
                    anchorEl={this.state.create_anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    onClose={this.createNewMenuClose}
                    className="margin-top-8"
                  >
                    <Paper style={{ width: 190 }}>
                      <div>
                        <List>
                          <ListItem
                            className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                            onClick={() => this.onEditJob(item, index)}
                          >
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">Edit</span>
                            </ListItemText>
                          </ListItem>

                          <ListItem
                            className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                            onClick={() => this.onDeleteJob(item, index)}
                          >
                            <ListItemText style={{ padding: 0 }}>
                              <span className="small-dark-secondary">
                                Delete
                              </span>
                            </ListItemText>
                          </ListItem>
                        </List>
                      </div>
                    </Paper>
                  </Popover>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </React.Fragment>
          ))}
        <Drawer
          anchor="right"
          open={this.state.drawerOpen}
          onClose={() =>
            this.setState({
              drawerOpen: false,
              isAddQuestion: false,
              isAddJob: false,
            })
          }
          classes={{
            paper: classNames(classes.drawerPaper, "planner-drawer"),
          }}
        >
          <DrawerHeader
            header={this.state.isAddJob ? "Add job" : "Add screening question"}
            isbackarrow={false}
            closeDrawer={() =>
              this.setState({
                drawerOpen: false,
                isAddQuestion: false,
                isAddJob: false,
              })
            }
          />
          {this.state.isAddJob && (
            <AddJobDrawer
              tempRequistionJobs={tempRequistionJobs}
              updatePostData={this.updatePostData}
              {...this.props}
              {...this.state}
            />
          )}
          {this.state.isAddQuestion && (
            <Grid container>
              <Grid item xs={12} md={12} sm={12}>
                <div>
                  <DynamicForm
                    fields={selectinputconverter({
                      value:
                        (this.state.tempRequistionQuestion &&
                          this.state.tempRequistionQuestion.questiontypeid) ||
                        questiontypeid,
                      placeholder: "Select category",
                      label: "Question category",
                      options: questioncategories,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("questiontypeid", selectedid);
                    }}
                  />
                  {(questiontypeid == 1 ||
                    (this.state.tempRequistionQuestion &&
                      this.state.tempRequistionQuestion.questiontypeid ==
                        1)) && (
                    <DynamicForm
                      fields={selectinputconverter({
                        value:
                          this.state.tempRequistionQuestion &&
                          this.state.tempRequistionQuestion.questionid,
                        placeholder: "Select question",
                        label: "Question",
                        options: this.state.arrQuestion,
                      })}
                      onChange={(selectedid) => {
                        this.handleChange("questionid", selectedid);
                      }}
                    />
                  )}

                  {(questiontypeid == 2 ||
                    (this.state.tempRequistionQuestion &&
                      this.state.tempRequistionQuestion.questiontypeid ==
                        2)) && (
                    <div>
                      <DynamicForm
                        className="width50"
                        fields={textareainputconverter({
                          value:
                            this.state.tempRequistionQuestion &&
                            this.state.tempRequistionQuestion.question
                              .questiontext,
                          placeholder: "Enter question",
                          label: "Question",
                        })}
                        onChange={(value) => {
                          this.handleChange("questiontext", value);
                        }}
                      />
                      <p className="small-dark-secondary margin-bottom-8">
                        Answer type
                      </p>
                      <div className="margin-bottom-8">
                        <img
                          src={alpha}
                          style={{
                            marginRight: 16,
                            cursor: "pointer",
                            border:
                              this.state.tempRequistionQuestion &&
                              this.state.tempRequistionQuestion.question
                                .inputvaluetypeid == 1
                                ? "2px solid #1e8ced"
                                : "2px solid transparent",
                            borderRadius: 20,
                          }}
                          onClick={() => this.setInputType(1)}
                        ></img>
                        <img
                          src={num}
                          style={{
                            marginRight: 16,
                            cursor: "pointer",
                            border:
                              this.state.tempRequistionQuestion &&
                              this.state.tempRequistionQuestion.question
                                .inputvaluetypeid == 2
                                ? "2px solid #1e8ced"
                                : "2px solid transparent",
                            borderRadius: 20,
                          }}
                          onClick={() => this.setInputType(2)}
                        ></img>
                        <img
                          src={dton}
                          style={{
                            marginRight: 16,
                            cursor: "pointer",
                            border:
                              this.state.tempRequistionQuestion &&
                              this.state.tempRequistionQuestion.question
                                .inputvaluetypeid == 3
                                ? "2px solid #1e8ced"
                                : "2px solid transparent",
                            borderRadius: 20,
                          }}
                          onClick={() => this.setInputType(3)}
                        ></img>
                        <img
                          src={dropdown}
                          style={{
                            marginRight: 16,
                            cursor: "pointer",
                            border:
                              this.state.tempRequistionQuestion &&
                              this.state.tempRequistionQuestion.question
                                .inputvaluetypeid == 4
                                ? "2px solid #1e8ced"
                                : "2px solid transparent",
                            borderRadius: 20,
                          }}
                          onClick={() => this.setInputType(4)}
                        ></img>
                        <img
                          src={checkboxIcon}
                          style={{
                            marginRight: 16,
                            cursor: "pointer",
                            border:
                              this.state.tempRequistionQuestion &&
                              this.state.tempRequistionQuestion.question
                                .inputvaluetypeid == 5
                                ? "2px solid #1e8ced"
                                : "2px solid transparent",
                            borderRadius: 20,
                          }}
                          onClick={() => this.setInputType(5)}
                        ></img>
                      </div>
                      {this.state.tempRequistionQuestion &&
                        this.state.tempRequistionQuestion.question
                          .inputvaluetypeid == 4 &&
                        this.state.tempRequistionQuestion.question
                          .requisitionjobquestioninputoption &&
                        this.state.tempRequistionQuestion.question.requisitionjobquestioninputoption.map(
                          (x, i) => (
                            <Grid
                              container
                              className="margin-top-8"
                              spacing={2}
                            >
                              <Grid item md={11} sm={12}>
                                <DynamicForm
                                  fields={textinputconverter({
                                    value: x.optionname,
                                    placeholder: "Enter option",
                                    label: `Option ${i + 1}`,
                                  })}
                                  onChange={(e) => {
                                    this.handleChange("optionname", e, i);
                                  }}
                                />
                              </Grid>
                              <Grid item md={1} sm={12}>
                                <img
                                  src={deleteIcon}
                                  style={{
                                    display: "table",
                                    marginRight: 8,
                                    marginTop: 26,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => this.removeOption(i)}
                                ></img>
                              </Grid>
                            </Grid>
                          ),
                        )}
                      {this.state.tempRequistionQuestion &&
                        this.state.tempRequistionQuestion.question
                          .inputvaluetypeid == 4 && (
                          <Button
                            className="btn btn-secondary-md-blue width100"
                            onClick={() => this.addOption()}
                          >
                            Add option
                          </Button>
                        )}

                      {this.state.tempRequistionQuestion &&
                        this.state.tempRequistionQuestion.question
                          .inputvaluetypeid == 5 &&
                        this.state.tempRequistionQuestion.question
                          .requisitionjobquestioninputoption &&
                        this.state.tempRequistionQuestion.question.requisitionjobquestioninputoption.map(
                          (x, i) => (
                            <Grid
                              container
                              className="margin-top-8"
                              spacing={2}
                            >
                              <Grid item md={11} sm={12}>
                                <DynamicForm
                                  fields={textinputconverter({
                                    value: x.optionname,
                                    placeholder: "Enter itme",
                                    label: `Item ${i + 1}`,
                                  })}
                                  onChange={(e) => {
                                    this.handleChange("optionname", e, i);
                                  }}
                                />
                              </Grid>
                              <Grid item md={1} sm={12}>
                                <img
                                  src={deleteIcon}
                                  style={{
                                    display: "table",
                                    marginRight: 8,
                                    marginTop: 26,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => this.removeOption(i)}
                                ></img>
                              </Grid>
                            </Grid>
                          ),
                        )}

                      {this.state.tempRequistionQuestion &&
                        this.state.tempRequistionQuestion.question
                          .inputvaluetypeid == 5 && (
                          <Button
                            className="btn btn-secondary-md-blue width100"
                            onClick={() => this.addOption()}
                          >
                            Add item
                          </Button>
                        )}
                      <div style={{ width: 400, marginTop: 16 }}>
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value: saveincompany,
                            placeholder: "",
                            label: "Save in Functional and role questions",
                          })}
                          onChange={(e) => {
                            this.handleChange("saveincompany", e, idx);
                          }}
                        />
                      </div>
                    </div>
                  )}
                  <Button
                    color="primary"
                    variant="contained"
                    type="button"
                    className="btn btn-primary-md-blue margin-top-8"
                    onClick={this.onSaveQuestion}
                  >
                    Add question
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
        </Drawer>
        <Popover
          open={this.state.moreoptions}
          anchorEl={this.state.moreoptions_anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={() => this.setState({ moreoptions: false })}
          className="margin-top-8"
        >
          <Paper style={{ width: 190 }}>
            <div>
              <List>
                {this.state.action != "editQuestion" &&
                  this.state.action != "addQuestion" && (
                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={() => this.editPopover()}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">Edit</span>
                      </ListItemText>
                    </ListItem>
                  )}
                <ListItem
                  className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                  onClick={this.deletePopover}
                >
                  <ListItemText style={{ padding: 0 }}>
                    <span className="small-dark-secondary">Delete</span>
                  </ListItemText>
                </ListItem>
              </List>
            </div>
          </Paper>
        </Popover>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
  Language: state.LanguageAction.Language,
  holidayPlanReducer: state.holidayPlanReducer,
  login: state.AuthenticationAction.login,
  SaveInProgressReducer: state.SaveInProgressReducer,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setSaveProgress, removeSaveProgress }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles, { withTheme: true })(withSnackbar(AddJobs)),
);
